import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import useTrainingTypes from '../hooks/useTrainingTypes'

const Card = ({ course, related, image, imageDefault, home }) => {

    const dataTrainingTypes = useTrainingTypes()
    const trainingTypes = dataTrainingTypes?.allStrapiTrainingType?.nodes
    const courseName = course?.name
    const microcredentialType = course?.microcredential_type
    
    // function capitalize(courseName) {
    //   const lower = courseName.toLowerCase()
    //   return courseName.charAt(0).toUpperCase() + lower.slice(1)
    // }

    return (
        <div
        className={`mb-4 col-12 col-lg-3 col-md-6 ${
          (course.featured && home) || related ? 'hightlighted' : ''
        }`}
        key={`noveltiesNodesId-${course.id}`}
      >
        <Link to={'/' + course.slug} className="text-decoration-none">
          <div className="h-100 d-flex flex-column rounded shadow-sm position-relative">
            {(course?.tag && !related && !course.featured) && (
              <div className={`card-tag card-tag-${course.tag?.color}`}>
                {course.tag?.title}
              </div>
            )}
            {image ? (
              <GatsbyImage
                image={image}
                alt={course.name}
                className="news-image"
              />
            ) : (
              <GatsbyImage
                image={imageDefault}
                alt={course.name}
                className="news-image"
              />
            )}
            <div className="flex-grow-1 p-4 d-flex flex-column news-info">
              <h6>
                <small>{course.dateStartQuery}</small>
              </h6>
              <div className="bg-sec px-2 py-1 text-white mb-2 fit-content">
                {course?.training_type?.title}
                {
                  trainingTypes.find(
                    (trainingType) =>
                      trainingType.strapiId == course.training_type
                  )?.title
                }
              </div>
              {microcredentialType ? (
              <div
                className="px-2 py-1 text-white mb-2 fit-content"
                style={{
                  backgroundColor:
                    microcredentialType === 'ES_MICROCREDENCIAL'
                      ? '#406a92'
                      : '#8CA9CF',
                }}
              >
                { microcredentialType === "ES_MICROCREDENCIAL" ? 'Microcredencial' : 'Aplica a Microcredencial' }
              </div>
              ) : null}
              <h5 className="font-weight-bold course-title text-break my-3">
                {courseName}
              </h5>
              <div className="mt-auto d-flex news-actions">
                <Link
                  to={'/' + course.slug}
                  className={
                    'btn btn-sm btn-outline fit-content text-uppercase rounded-pill font-secondary eventuality-button-font-size news-action-btn'
                  }
                >
                  Ver más
                </Link>
                {microcredentialType ? (
                  <Link
                    to={'/microcredenciales'}
                    className={
                      'btn btn-sm btn-solid  fit-content text-uppercase rounded-pill px-4 font-secondary eventuality-button-font-size news-action-btn microcredential-btn'
                    }
                  >
                    Ir a microcredenciales
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
        </Link>
        
      </div>
    )
}

export default Card

Card.propTypes = {
    course: PropTypes.object,
    related: PropTypes.bool,
    image: PropTypes.object,
    imageDefault: PropTypes.object,
    home: PropTypes.bool
  }
  
